export enum FuelCardActionTypes {
  DOWNLOAD_TRANSACTIONS_REPORT_REQUEST = 'DOWNLOAD_TRANSACTIONS_REPORT_REQUEST',
  DOWNLOAD_TRANSACTIONS_REPORT_END = 'DOWNLOAD_TRANSACTIONS_REPORT_END',
  LOAD_FUEL_VEHICLES_REQUEST = 'LOAD_FUEL_VEHICLES_REQUEST',
  LOAD_FUEL_VEHICLES_SUCCEEDED = 'LOAD_FUEL_VEHICLES_SUCCEEDED',
  LOAD_FUEL_VEHICLES_FAILED = 'LOAD_FUEL_VEHICLES_FAILED',
  UPDATE_FUEL_VEHICLES_REQUEST = 'UPDATE_FUEL_VEHICLES_REQUEST',
  UPDATE_FUEL_VEHICLES_END = 'UPDATE_FUEL_VEHICLES_END',
  LOAD_FUEL_CARD_MATCHINGS_REQUEST = 'LOAD_FUEL_CARD_MATCHINGS_REQUEST',
  LOAD_FUEL_CARD_MATCHINGS_SUCCEEDED = 'LOAD_FUEL_CARD_MATCHINGS_SUCCEEDED',
  LOAD_FUEL_CARD_MATCHINGS_FAILED = 'LOAD_FUEL_CARD_MATCHINGS_FAILED',
  SAVE_FUEL_CARD_MATCHING_REQUEST = 'SAVE_FUEL_CARD_MATCHING_REQUEST',
  SAVE_FUEL_CARD_MATCHING_SUCCEEDED = 'SAVE_FUEL_CARD_MATCHING_SUCCEEDED',
  SAVE_FUEL_CARD_MATCHING_FAILED = 'SAVE_FUEL_CARD_MATCHING_FAILED',
}
